import { render } from "./Menu.vue?vue&type=template&id=060db909"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/seguridad/Menu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "060db909"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('060db909', __exports__)) {
    api.reload('060db909', __exports__)
  }
  
  module.hot.accept("./Menu.vue?vue&type=template&id=060db909", () => {
    api.rerender('060db909', render)
  })

}


export default __exports__